export const getLoading = (state) => state.statistics.base.offers.loading;
export const getError = (state) =>  state.statistics.base.offers.error;
export const getData = (state) =>  state.statistics.base.offers.data;
